export default __webpack_public_path__ + "static/media/arrow-single-down.4d5a885d.svg";